<div class="container" *ngIf="show">
    <div class="loader"></div>
</div>
